import { Record, List } from 'immutable';
import { MenuItemAnalyses } from 'records/MenuItemAnalysis';

const defaultValues = {
  userCategoryId: null,
  categoryName: null,
  periodProfit: 0,
  annualProfit: 0,
  avgPrice: 0,
  avgCost: 0,
  avgCostPercentage: 0,
  avgProfit: 0,
  periodicUnitsSold: 0,
  menuAnalysisItemList: MenuItemAnalyses(),
};

export default class MenuCategoryAnalysis extends Record(defaultValues, MenuCategoryAnalysis) {
  constructor(values) {
    super({
      ...values,
      menuAnalysisItemList: values && values.menuAnalysisItemList
                          ? MenuItemAnalyses(values.menuAnalysisItemList)
                          : defaultValues.menuAnalysisItemList,

    });
  }

  static getMenuCategoryAnalysisByCategoryId(menuCategoryAnalysis, categoryId) {
    return menuCategoryAnalysis.filter((menuCategory) => {
      return menuCategory.get('userCategoryId') === categoryId;
    });
  }
}

export const MenuCategoryAnalyses = (data) => {
  let menuCategoryAnalyses = new List();
  if (data) {
    data.forEach((value) => {
      menuCategoryAnalyses = menuCategoryAnalyses.push((value instanceof MenuCategoryAnalysis) ? value : (new MenuCategoryAnalysis(value)));
    });
  }
  return menuCategoryAnalyses;
}
